"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _coreDecorators = require("core-decorators");

var _Desktop = require("./Desktop");

var _Mobile = require("./Mobile");

var _class, _class2;

var Filter = (0, _emotionTheming.withTheme)(_class = (_class2 =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Filter, _React$Component);

  function Filter(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Filter);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Filter).call(this, props));
    _this.controlledSelectedItems = false;

    if (Array.isArray(_this.props.selectedItemsGroupArray)) {
      _this.controlledSelectedItems = true;
    }

    return _this;
  }

  (0, _createClass2.default)(Filter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          className = _this$props.className,
          viewType = _this$props.viewType,
          groups = _this$props.groups,
          selectedKeys = _this$props.selectedKeys,
          selectedItemsGroupArray = _this$props.selectedItemsGroupArray,
          withSearch = _this$props.withSearch,
          onSearch = _this$props.onSearch,
          groupClassName = _this$props.groupClassName;
      var selectedKeysSet;

      if (Array.isArray(selectedItemsGroupArray)) {
        selectedKeysSet = new Set([].concat.apply([], selectedItemsGroupArray.map(function (item) {
          return item.selectedItemsArray.map(function (selectedItem) {
            return selectedItem.key;
          });
        })));
      } else {
        selectedKeysSet = new Set(selectedKeys);
      }

      switch (viewType) {
        case 'desktop':
          return _react.default.createElement(_Desktop.Desktop, {
            theme: theme,
            className: className,
            groups: groups,
            selectedKeysSet: selectedKeysSet,
            selectedItemsGroupArray: selectedItemsGroupArray,
            controlledSelectedItems: this.controlledSelectedItems,
            onSelectKey: this.selectKeyHandler,
            onRemoveKey: this.removeKeyHandler,
            withSearch: withSearch,
            onSearch: onSearch,
            groupClassName: groupClassName
          });

        case 'mobile':
          return _react.default.createElement(_Mobile.Mobile, {
            theme: theme,
            className: className,
            groups: groups,
            selectedKeysSet: selectedKeysSet,
            selectedItemsGroupArray: selectedItemsGroupArray,
            controlledSelectedItems: this.controlledSelectedItems,
            onSelectKey: this.selectKeyHandler,
            onRemoveKey: this.removeKeyHandler,
            withSearch: withSearch,
            onSearch: onSearch,
            groupClassName: groupClassName
          });

        default:
          return false;
      }
    }
  }, {
    key: "selectKeyHandler",
    value: function selectKeyHandler(key, item, groupIndex) {
      var keys = [].concat((0, _toConsumableArray2.default)(this.props.selectedKeys), [key]);
      this.props.onChange(keys, item, groupIndex);
    }
  }, {
    key: "removeKeyHandler",
    value: function removeKeyHandler(key, item, groupIndex) {
      var keys = this.props.selectedKeys.filter(function (k) {
        return k !== key;
      });
      this.props.onChange(keys, item, groupIndex, true);
    }
  }]);
  return Filter;
}(_react.default.Component), ((0, _applyDecoratedDescriptor2.default)(_class2.prototype, "selectKeyHandler", [_coreDecorators.autobind], Object.getOwnPropertyDescriptor(_class2.prototype, "selectKeyHandler"), _class2.prototype), (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "removeKeyHandler", [_coreDecorators.autobind], Object.getOwnPropertyDescriptor(_class2.prototype, "removeKeyHandler"), _class2.prototype)), _class2)) || _class;

Filter.propTypes = {
  viewType: _propTypes.default.oneOf(['desktop', 'mobile']),
  groups: _propTypes.default.array.isRequired,
  selectedKeys: _propTypes.default.array,
  selectedItemsGroupArray: _propTypes.default.array,
  onChange: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  onSearch: _propTypes.default.func
};
Filter.defaultProps = {
  viewType: 'desktop',
  className: '',
  selectedKeys: [],
  selectedItemsGroupArray: null,
  onSearch: function onSearch() {}
};
var _default = Filter;
exports.default = _default;